const customMediaQuery = (minWidth: number) => `@media (min-width: ${minWidth}px)`;
export const media = {
	custom: customMediaQuery,
	condensed: customMediaQuery(1200),
	smallScreen: customMediaQuery(900),
	landscape: `@media (min-aspect-ratio: 13/9)`,
};
